import { CaregiverAllMessagesPage } from "./caregiverAllMessages";

export const CaregiverAllMessages = CaregiverAllMessagesPage;
